import { createSlice } from '@reduxjs/toolkit';
import { getCalls } from '../thunks/calls.thunk';
import { addCallsSliceExtraReducers } from './callsSliceExtraReducers.util';
import { callsSliceReducers } from './callsSliceReducers.util';
import { callsInitialState } from './callsSliceState.util';
import {
  createCallsSliceWebsocketActions,
  registerCallsSliceEffects,
} from './callsSliceEffects.util';

export { getCalls };
export * from './callsSliceThunks.thunk';
export * from './callsSliceSelectors.util';

export const callsSlice = createSlice({
  name: 'calls',
  initialState: callsInitialState,
  reducers: callsSliceReducers,
  extraReducers: addCallsSliceExtraReducers,
});

export const callsReducer = callsSlice.reducer;
export const { removeCallFromState } = callsSlice.actions;

registerCallsSliceEffects(callsSlice);
export const callsSliceWebsocketActions =
  createCallsSliceWebsocketActions(callsSlice);
